import { DashboardLayout } from '@modules/dashboard/components/DashboardContents/DashboardLayout';
import { trackDashboardEvent } from '@modules/dashboard/helpers';
import { useUpdateStoreForNewDashboard } from '@modules/dashboard/hooks';
import { DashboardActionType } from '@modules/dashboard/store/dashboardActionType';
import { useDashboardStore } from '@modules/dashboard/store/useDashboardStore';
import { QueryBuilderStoreProvider } from '@modules/queryBuilder/store/QueryBuilderStoreProvider';
import { Box, Stack } from '@mui/material';
import { useEffect, useRef } from 'react';
import useParseSavedSlugInfo from 'v2/core/services/savedSlug/useParseSavedSlugInfo';
import { DashboardContents } from '../DashboardContents';

export const Dashboard = () => {
  useUpdateStoreForNewDashboard();
  const { token: viewTokenFromURL } = useParseSavedSlugInfo();
  const dispatch = useDashboardStore(({ dispatch }) => dispatch);
  const viewToken = useDashboardStore(({ dashboard }) => dashboard.viewToken);
  const editToken = useDashboardStore(({ dashboard }) => dashboard.editToken);

  const dependencies = { viewToken, editToken };
  const dependenciesRef = useRef(dependencies);
  dependenciesRef.current = dependencies;

  useEffect(() => {
    trackDashboardEvent({
      eventName: 'Dashboard Opened',
      dashboardLink: window.location.href,
    });
  }, []);

  // Reset only if view-token from URL is different from the store view-token
  useEffect(() => {
    if (
      viewTokenFromURL === dependenciesRef.current.viewToken ||
      viewTokenFromURL === dependenciesRef.current.editToken
    ) {
      return;
    }

    return () => {
      dispatch({
        type: DashboardActionType.RESET,
      });
    };
  }, [dispatch, viewTokenFromURL]);

  // Reset on unmount
  useEffect(() => {
    return () => {
      dispatch({
        type: DashboardActionType.RESET,
      });
    };
  }, [dispatch]);

  return (
    <Box key={viewTokenFromURL}>
      <QueryBuilderStoreProvider>
        <Stack spacing={2} px={3}>
          {viewTokenFromURL ? (
            <DashboardContents />
          ) : (
            <DashboardLayout isLoading={false} />
          )}
        </Stack>
      </QueryBuilderStoreProvider>
    </Box>
  );
};
